import { useSelector } from 'react-redux';
import { addTheParks } from '../Redux/actions';
import { theParksSelector } from '../Redux/selectors';
import { WithFetchJsonContent } from './WithFetchJsonContent';

export const WithParks = ({ children }) => {
  const parksData = useSelector(theParksSelector);

  return (
    <WithFetchJsonContent reduxInStore={parksData} addToReduxFunction={addTheParks} jsonLocation="PARKLIST">
      {children}
    </WithFetchJsonContent>
  );
}
